import AMLScan from './AMLScan';

export default AMLScan;
